export default __webpack_public_path__ + "static/media/speak.f8fbff6b.svg";